import {TextInput} from "react-native";
import Page from "@/lib/pages/Page";
import Center from "@/lib/components/Center";
import Header from "@/lib/components/Header";
import globstyles from "@/lib/globstyles";
import {Color} from "@/lib/styles";
import {useState} from "react";
import Nav from "@/lib/components/Nav";
import ActionButton from "@/lib/components/ActionButton";
import {fetchBackend} from "@/lib/backend";
import {useSession} from "@/lib/auth/auth";
import {EditGroupRequest, Group} from "@/lib/types";
import {useRouter} from "expo-router";
import ErrorMessage from "@/lib/components/ErrorMessage";
import Message from "@/lib/components/Message";
import {useQueryClient} from "@tanstack/react-query";

export default function Create() {
    const {session} = useSession();
    const router = useRouter();
    const queryClient = useQueryClient();

    const [name, setName] = useState("");
    const [error, setError] = useState<Error | null>(null);
    const [busy, setBusy] = useState(false);

    async function submitGroup() {
        setError(null);
        setBusy(true);
        const request: EditGroupRequest = {name};
        fetchBackend<Group>(`/group`, "POST", session, request).then(async (group) => {
            await queryClient.invalidateQueries({queryKey: ['group', session]});
            router.replace(`/s/${group.group_id}/edit`);
        }).catch((error) => {
            setError(error);
        }).finally(() => {
            setBusy(false);
        });
    }

    return (
        <Page>
            <Center width={330} style={{gap: 16}}>
                <Header title={"Skap et nytt samfunn"} center={true}/>
                <Message
                    text={"Inviter venner og bekjente. Del interesser. Skap noe sammen."}/>
                <TextInput style={[globstyles.formTextInput]}
                           placeholder={"Hva heter samfunnet?"}
                           placeholderTextColor={Color.FadedText}
                           value={name}
                           onChangeText={(text) => {
                               setName(text);
                           }}
                           inputMode={"text"}
                           returnKeyType={"send"}
                           enablesReturnKeyAutomatically={true}
                           autoFocus={true}
                           focusable={true}
                           keyboardAppearance={"dark"}
                           submitBehavior={"submit"}
                           onSubmitEditing={submitGroup}
                />
                {error && <ErrorMessage error={error}/>}
                <Nav>
                    <ActionButton
                        onPress={submitGroup}
                        title={"Lagre og tilpass"}
                        icon={"edit"}
                        busy={busy}
                    />
                </Nav>
            </Center>
        </Page>
    )
}